import { Component, Input } from '@angular/core';
import { PersonalDataRequestStatusEnum } from '../../core/enums/personal-data-request-status.enum';

@Component({
    selector: 'app-request-status-icon',
    templateUrl: './request-status-icon.component.html',
    styleUrls: ['./request-status-icon.component.scss'],
})
export class RequestStatusIconComponent {
    @Input() status: PersonalDataRequestStatusEnum;

    PersonalDataRequestStatusEnum = PersonalDataRequestStatusEnum;
}
